<div class="container">
  <!-- Formulário de login -->
  <div class="accountant-form" *ngIf="!isAuthenticated">
    <form [formGroup]="accountantForm" (submit)="onSendSignup($event)">
      <label for="email">Email do contador</label>
      <input id="email" formControlName="email" type="email" required [class.readonly]="showCode">

      <div class="code" *ngIf="showCode">
        <label for="codigo">Código</label>
        <input id="codigo" formControlName="codigo" type="text" required>
      </div>

      <button type="button" [disabled]="isLoading" (click)="onSendCode()" *ngIf="!showCode">
        {{ isLoading ? 'Enviando...' : 'Enviar código' }}
      </button>

      <button type="submit" [disabled]="isLoading" *ngIf="showCode">
        {{ isLoading ? 'Acessando...' : 'Entrar' }}
      </button>
    </form>
  </div>

  <!-- Dados do contador + tabela de clientes -->
  <div class="accountant-panel" *ngIf="isAuthenticated">
    <div class="accountant-header">
      <h2>{{ accountantName }}</h2>
      <div>
        <p>{{ accountantEmail }}</p>
        <p class="document">{{ accountantDocument }}</p>
      </div>
    </div>

    <h3>Clientes vinculados</h3>

    <table mat-table [dataSource]="clients" *ngIf="clients.length > 0" class="mat-elevation-z8">
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef>Razão Social</th>
        <td mat-cell *matCellDef="let client">{{ client.companyName ?? "Não Cadastrado" }}</td>
      </ng-container>

      <ng-container matColumnDef="fantasyName">
        <th mat-header-cell *matHeaderCellDef>Nome Fantasia</th>
        <td mat-cell *matCellDef="let client">{{ client.fantasyName ?? "Não Cadastrado" }}</td>
      </ng-container>

      <ng-container matColumnDef="cnpj">
        <th mat-header-cell *matHeaderCellDef>CNPJ</th>
        <td mat-cell *matCellDef="let client">{{ client.documentCompany }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let client">{{ client.email }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Ação</th>
        <td mat-cell *matCellDef="let client" class="link-access">
          <a (click)="onAccessClient(client)" class="action-link">
            <mat-icon>link</mat-icon>
            Acessar
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <p *ngIf="clients.length === 0" class="no-clients">Nenhum cliente vinculado.</p>
  </div>
</div>
